<script setup lang="ts">
  const props = defineProps({
    class: {
      type: String,
      required: false,
      default: undefined,
    },
    width: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    height: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
  })
</script>

<template>
  <svg
    :width="props.width || 20"
    :height="props.height || 20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="[props.class || 'text-gray-400']"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.80249 5.97852C1.80249 5.42623 2.1695 4.97852 2.62223 4.97852H17.3776C17.8303 4.97852 18.1974 5.42623 18.1974 5.97852C18.1974 6.5308 17.8303 6.97852 17.3776 6.97852H2.62223C2.1695 6.97852 1.80249 6.5308 1.80249 5.97852ZM1.80249 14.02C1.80249 13.4677 2.1695 13.02 2.62223 13.02H17.3776C17.8303 13.02 18.1974 13.4677 18.1974 14.02C18.1974 14.5723 17.8303 15.02 17.3776 15.02H2.62223C2.1695 15.02 1.80249 14.5723 1.80249 14.02Z"
      :fill="'currentColor'"
    />
  </svg>
</template>
